/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PractitionerSearchResult
 */
export interface PractitionerSearchResult {
    /**
     * Null for NPPES results, which have no ExaCare record until saved.
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    id: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    first_name: string;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    last_name: string;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    npi: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    credential?: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    address_line?: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    city?: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    state?: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    zip?: string | null;
    /**
     *
     * @type {string}
     * @memberof PractitionerSearchResult
     */
    source: PractitionerSearchResultSourceEnum;
}


/**
 * @export
 */
export const PractitionerSearchResultSourceEnum = {
    Local: 'local',
    Nppes: 'nppes'
} as const;
export type PractitionerSearchResultSourceEnum = typeof PractitionerSearchResultSourceEnum[keyof typeof PractitionerSearchResultSourceEnum];


/**
 * Check if a given object implements the PractitionerSearchResult interface.
 */
export function instanceOfPractitionerSearchResult(value: object): value is PractitionerSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function PractitionerSearchResultFromJSON(json: any): PractitionerSearchResult {
    return PractitionerSearchResultFromJSONTyped(json, false);
}

export function PractitionerSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PractitionerSearchResult {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'],
        'credential': json['credential'] == null ? undefined : json['credential'],
        'address_line': json['address_line'] == null ? undefined : json['address_line'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'source': json['source'],
    };
}

export function PractitionerSearchResultToJSON(json: any): PractitionerSearchResult {
    return PractitionerSearchResultToJSONTyped(json, false);
}

export function PractitionerSearchResultToJSONTyped(value?: PractitionerSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'npi': value['npi'],
        'credential': value['credential'],
        'address_line': value['address_line'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'source': value['source'],
    };
}
